<template>
  <div>
    <b-row class="align-items-baseline">
      <b-col class="col-md-2">
        <AppSearchInput
          v-model="filter.search"
          :label="$t('search') + ':'"
          :placeholder="$t('search') + '...'"
          @callback="onFiltered"
        />
      </b-col>
      <b-col class="col-md-2">
        <b-form-group :label="$t('filter_by_category') + ':'">
          <v-select
            class="bg-white rounded"
            label="title"
            v-model="categoryTable"
            :reduce="(data) => data.id"
            :options="
              card
                ? product_categories.results
                : GET_INSTRUMENT_CATEGORIES.results
            "
            :filterable="false"
            @search="onSearch"
            @input="onFiltered"
          >
            <li slot="list-footer" class="pagination">
              <button
                :disabled="
                  card
                    ? !product_categories.previous
                    : !GET_INSTRUMENT_CATEGORIES.previous
                "
                @click="prevCateg"
              >
                {{ $t("prev") }}
              </button>
              <button
                :disabled="
                  card
                    ? !product_categories.next
                    : !GET_INSTRUMENT_CATEGORIES.next
                "
                @click="nextCateg"
              >
                {{ $t("next") }}
              </button>
            </li>
          </v-select>
        </b-form-group>
      </b-col>
      <b-col class="col-md-2">
        <b-form-group :label="$t('filter_by_type') + ':'">
          <v-select
            v-model="productType"
            class="bg-white rounded"
            label="title"
            :reduce="(data) => data.id"
            :options="
              card ? GET_MATERIALS.results : GET_INSTRUMENTS_MODEL.results
            "
            :filterable="false"
            @search="onSearch1"
            @input="onFiltered1"
          >
            <li slot="list-footer" class="pagination">
              <button
                :disabled="
                  card
                    ? !GET_MATERIALS.previous
                    : !GET_INSTRUMENTS_MODEL.previous
                "
                @click="previous"
              >
                {{ $t("prev") }}
              </button>
              <button
                :disabled="
                  card ? !GET_MATERIALS.next : !GET_INSTRUMENTS_MODEL.next
                "
                @click="nextFunc"
              >
                {{ $t("next") }}
              </button>
            </li>
          </v-select>
        </b-form-group>
      </b-col>

      <b-col
        class="d-flex align-items-center justify-content-end"
        style="margin-top: 10px"
      >
        <b-form-radio-group
          id="radio-dark"
          v-model="card"
          class="list item-view-radio-group"
          buttons
          button-variant="outline-primary"
          @input="changeRadio"
        >
          <b-form-radio
            v-for="option in itemViewOptions"
            :key="option.value"
            :value="option.value"
          >
            {{ option.text }}
          </b-form-radio>
        </b-form-radio-group>
      </b-col>
    </b-row>
    <div v-if="!isLoading">
      <template v-if="card">
        <materialTable />
      </template>
      <template v-else>
        <instrumenTable />
      </template>
    </div>
    <b-card v-else>
      <Loader />
    </b-card>

    <Pagination
      v-if="card"
      :params="filter"
      :rows="GET_MATERIALS_FOR_BUILDERS.count"
      @refresh="FETCH_MATERIAL_FOR_BUILDERS"
    />
    <Pagination
      v-else
      :params="filter"
      :rows="GET_ISNTRUMENTS_REMAINS_BUILDERS.count"
      @refresh="FETCH_INSTRUMENTS_REMAINS_BUILDERS"
    />
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BTable,
  BCard,
  BButton,
  BFormGroup,
  BFormRadio,
  BFormRadioGroup,
} from "bootstrap-vue";
import { mapActions, mapGetters, mapState } from "vuex";
import AppSearchInput from "@/components/AppSearchInput.vue";
import Pagination from "@/components/Pagination.vue";
import addPtoModal from "./components/addPto2Modal.vue";
import returnModal from "./components/returnModal.vue";
import VSelect from "vue-select";
import check from "@/mixins/check";
import materialModal from "./components/materialModal.vue";
import materialTable from "./components/tables/MaterialTable.vue";
import instrumenTable from "./components/tables/InstrumentsTable.vue";
import loader from "@/mixins/loader";
import Loader from "@/components/Loader.vue";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BTable,
    BButton,
    Loader,
    BFormGroup,
    BFormRadio,
    BFormRadioGroup,
    AppSearchInput,
    Pagination,
    VSelect,
    addPtoModal,
    materialModal,
    returnModal,
    materialTable,
    instrumenTable,
  },
  data() {
    return {
      isLoading: false,
      item: null,
      card: true,
      data_item: null,
      productType: null,
      categoryTable: null,
      filter: {
        is_object: 0,
        search: null,
        object: null,
        storage: null,
        page: 1,
        page_size: 10,
      },

      itemViewOptions: [
        {
          text: this.$t("reference.material"),
          value: true,
        },
        {
          text: this.$t("reference.instrument"),
          value: false,
        },
      ],
    };
  },
  mixins: [check, loader],
  computed: {
    ...mapGetters("materials", ["GET_MATERIALS_FOR_BUILDERS", "GET_MATERIALS"]),
    ...mapState("materials", ["product_categories"]),
    ...mapGetters("instruments", [
      "GET_ISNTRUMENTS_REMAINS_BUILDERS",
      "GET_INSTRUMENT_CATEGORIES",
      "GET_INSTRUMENTS_MODEL",
    ]),
  },
  async mounted() {
    // await this.$_loaderStart();
    this.isLoading = true;
    await this.FETCH_MATERIAL_FOR_BUILDERS();
    await this.FETCH_INSTRUMENTS_REMAINS_BUILDERS();
    // await this.FETCH_MATERIALS();
    await this.FETCH_PRODUCT_CATEGORIES({ pagination: "number" });
    await this.FETCH_INSTRUMENTS_CATEGORY({ pagination: "number" });
    // await this.FETCH_INSTRUMENTS_MODEL();
    this.isLoading = false;
  },

  // async beforeRouteLeave(to, from, next) {
  //   await this.$_loaderStop();
  //   next();
  // },
  methods: {
    ...mapActions("materials", [
      "FETCH_PRODUCT_CATEGORIES",
      "FETCH_MATERIALS",
      "FETCH_MATERIAL_FOR_BUILDERS",
    ]),

    ...mapActions("instruments", [
      "FETCH_INSTRUMENTS_REMAINS_BUILDERS",
      "FETCH_INSTRUMENTS_CATEGORY",
      "FETCH_INSTRUMENTS_MODEL",
    ]),

    async refresh() {
      if (this.card) {
        this.isLoading = true;
        await this.FETCH_MATERIAL_FOR_BUILDERS(this.filter);
        this.isLoading = false;
      } else {
        this.isLoading = true;

        await this.FETCH_INSTRUMENTS_REMAINS_BUILDERS(this.filter);
        this.isLoading = false;
      }
    },

    async nextCateg() {
      if (this.card) {
        if (this.product_categories.next) {
          const page = this.product_categories.next;
          await this.FETCH_PRODUCT_CATEGORIES({
            pagination: "number",
            page: page,
          });
        }
      } else {
        if (this.GET_INSTRUMENT_CATEGORIES.next) {
          const page = this.GET_INSTRUMENT_CATEGORIES.next;
          await this.FETCH_INSTRUMENTS_CATEGORY({
            pagination: "number",
            page: page,
          });
        }
      }
    },

    async prevCateg() {
      if (this.card) {
        if (this.product_categories.previous) {
          const page = this.product_categories.previous;
          await this.FETCH_PRODUCT_CATEGORIES({
            pagination: "number",
            page: page,
          });
        }
      } else {
        if (this.GET_INSTRUMENT_CATEGORIES.previous) {
          const page = this.GET_INSTRUMENT_CATEGORIES.previous;
          await this.FETCH_INSTRUMENTS_CATEGORY({
            pagination: "number",
            page: page,
          });
        }
      }
    },

    async nextFunc() {
      if (this.card) {
        if (this.GET_MATERIALS.next) {
          const page = this.GET_MATERIALS.next;
          await this.FETCH_MATERIALS({
            pagination: "number",
            page: page,
          });
        }
      } else {
        if (this.GET_INSTRUMENTS_MODEL.next) {
          const page = this.GET_INSTRUMENTS_MODEL.next;
          await this.FETCH_INSTRUMENTS_MODEL({
            pagination: "number",
            page: page,
          });
        }
      }
    },

    async previous() {
      if (this.card) {
        if (this.GET_MATERIALS.previous) {
          const page = this.GET_MATERIALS.previous;
          await this.FETCH_MATERIALS({
            pagination: "number",
            page: page,
          });
        }
      } else {
        if (this.GET_INSTRUMENTS_MODEL.previous) {
          const page = this.GET_INSTRUMENTS_MODEL.previous;

          await this.FETCH_INSTRUMENTS_MODEL({
            pagination: "number",
            page: page,
          });
        }
      }
    },

    async onSearch1(query) {
      if (this.card) {
        await this.FETCH_MATERIALS({
          pagination: "number",
          search: query,
        });
      } else {
        await this.FETCH_INSTRUMENTS_MODEL({
          pagination: "number",
          search: query,
        });
      }
    },

    async onSearch(query) {
      if (this.card) {
        await this.FETCH_PRODUCT_CATEGORIES({
          pagination: "number",
          search: query,
        });
      } else {
        await this.FETCH_INSTRUMENTS_CATEGORY({
          pagination: "number",
          search: query,
        });
      }
    },

    async changeRadio() {
      this.filter.search = null;
      this.categoryTable = null;
      this.productType = null;

      if (this.card) {
        await this.FETCH_MATERIALS();
        // await this.FETCH_PRODUCT_CATEGORIES();
        await this.FETCH_MATERIAL_FOR_BUILDERS({
          search: this.filter.search,

          product__category: this.categoryTable,
          product: this.productType,
        });
      } else {
        await this.FETCH_INSTRUMENTS_REMAINS_BUILDERS({
          search: this.filter.search,

          type__category: this.categoryTable,
          type: this.productType,
        });
        await this.FETCH_INSTRUMENTS_CATEGORY();
        // await this.FETCH_INSTRUMENTS_MODEL();
      }
    },

    returnItems(data) {
      this.data_item = data;
      this.$nextTick(() => {
        this.$bvModal.show("return-modal");
      });
    },

    addPto(data) {
      this.item = data;

      this.$nextTick(() => {
        this.$bvModal.show("add-pto2-modal");
      });
    },

    async onFiltered1() {
      this.filter.page = 1;
      if (this.card) {
        this.isLoading = true;
        if (this.categoryTable == 0) {
          await this.FETCH_MATERIALS({ pagination: "number" });
          return;
        } else {
          await this.FETCH_MATERIALS({
            category: this.categoryTable,
            pagination: "number",
          });
          await this.FETCH_MATERIAL_FOR_BUILDERS({
            search: this.filter.search,
            page: this.filter.page,
            page_size: this.filter.page_size,
            product__category: this.categoryTable,
            product: this.productType,
          });
        }
        this.isLoading = false;
      } else {
        this.isLoading = true;

        if (this.categoryTable == 0) {
          await this.FETCH_INSTRUMENTS_MODEL({ pagination: "number" });
          return;
        } else {
          await this.FETCH_INSTRUMENTS_MODEL({
            category: this.categoryTable,
            pagination: "number",
          });
          await this.FETCH_INSTRUMENTS_REMAINS_BUILDERS({
            search: this.filter.search,
            page: this.filter.page,
            page_size: this.filter.page_size,
            type__category: this.categoryTable,
            type: this.productType,
          });
        }
        this.isLoading = false;
      }

      // if (!this.categoryTable) {
      //   if (this.card) {
      //     await this.FETCH_MATERIALS();
      //   } else {
      //     await this.FETCH_INSTRUMENTS_MODEL();
      //   }
      // }
    },

    async onFiltered() {
      // this.productType = null;
      this.productType = null;
      this.filter.page = 1;

      if (this.card) {
        this.isLoading = true;
        if (this.categoryTable == 0) {
          await this.FETCH_MATERIALS({ pagination: "number" });
          return;
        } else {
          await this.FETCH_MATERIALS({
            category: this.categoryTable,
            pagination: "number",
          });
          await this.FETCH_MATERIAL_FOR_BUILDERS({
            search: this.filter.search,
            page: this.filter.page,
            page_size: this.filter.page_size,
            product__category: this.categoryTable,
            product: this.productType,
          });
        }
        this.isLoading = false;
      } else {
        this.isLoading = true;

        if (this.categoryTable == 0) {
          await this.FETCH_INSTRUMENTS_MODEL({ pagination: "number" });
          return;
        } else {
          await this.FETCH_INSTRUMENTS_MODEL({
            category: this.categoryTable,
            pagination: "number",
          });
          await this.FETCH_INSTRUMENTS_REMAINS_BUILDERS({
            search: this.filter.search,
            page: this.filter.page,
            page_size: this.filter.page_size,
            type__category: this.categoryTable,
            type: this.productType,
          });
        }
        this.isLoading = false;
      }

      // if (!this.categoryTable) {
      //   if (this.card) {
      //     await this.FETCH_MATERIALS();
      //   } else {
      //     await this.FETCH_INSTRUMENTS_MODEL();
      //   }
      // }
    },
    // async search(text) {
    //   this.filter.search = text;
    //   await this.FETCH_MATERIAL_FOR_BUILDERS(this.filter);
    // },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

#user-table {
  border-collapse: separate;
  border-spacing: 0 1rem;
}

#user-table .tableRowClass {
  background: white;
  transform: translateY(5px);
  transition: all 0.5s ease-in-out;
  text-align: center;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

  td {
    border-top: 0;
    padding: 20px !important;

    &:first-child {
      border-top-left-radius: 0.5rem;
      border-bottom-left-radius: 0.5rem;
    }

    &:last-child {
      border-top-right-radius: 0.5rem;
      border-bottom-right-radius: 0.5rem;
    }
  }
}

#user-table .tableRowClass:hover {
  transform: translateY(0);
}

#user-table .tableHeadClass {
  background: none !important;
  border: none !important;
}

#user-table .tableRowClass:hover {
  .tableTitle {
    color: #7367f0 !important;
  }
}

.tableHeadClass {
  text-align: center;
  padding-left: 0 !important;
}

.pagination {
  display: flex;
  margin: 0.25rem 0.25rem 0;
}
.pagination button {
  flex-grow: 1;
  border: 1px solid #ccc;
}
.pagination button:hover {
  cursor: pointer;
}
</style>
